"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromCAC = void 0;
//@ts-nocheck
var fromCAC = [
    {
        artifact_id: 10052468,
        type: "CLINICAL",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 11147912,
                    procedure_name: null,
                    procedure_code: "76140",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    automate: false,
                    confidence: -1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        primary_code_confidence: 0.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: false
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            primary_code_confidence: -1.0,
            primary_predicted_code: null,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 10087892,
        type: "PROCESSED",
        identifier: "3318928",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_id: 11185331,
                    procedure_name: null,
                    procedure_code: "76140",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    automate: true,
                    confidence: 1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: true,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "77",
                                automate: false,
                                confidence: 1.0,
                                sequence_number: 1,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "ACT",
                                automate: false,
                                confidence: 1.0,
                                sequence_number: 2,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 0.27,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "R91.8",
                                automate: false,
                                confidence: 0.27,
                                sequence_number: 1,
                                type: null,
                                evidence: [
                                    {
                                        type: "Categorical",
                                        score: 0.10500784882327382,
                                        feature: {
                                            category: "Non-specific",
                                            field: "body_region",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.043968009866781406,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "abnorm",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.03157402076577271,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "prior",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.01344278294668012,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "diagnost outsid",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 49,
                                                    end: 85,
                                                    level: "ngram",
                                                    content: "Diagnostic CT NEURO-VASCULAR OUTSIDE"
                                                },
                                                {
                                                    start: 37,
                                                    end: 167,
                                                    level: "sentence",
                                                    content: " TECHNIQUE: Diagnostic CT NEURO-VASCULAR OUTSIDE WITH INTERPRETATION OR CONSULT, CT HEAD OUTSIDE WITH INTERPRETATION OR CONSULT.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.006724147603631276,
                                        feature: {
                                            category: "XRAY",
                                            field: "procedure_category",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.006724147603631276,
                                        feature: {
                                            category: "Digital Radiography",
                                            field: "procedure_type",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.004187631487871611,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "appear",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 1161,
                                                    end: 1167,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1117,
                                                    end: 1176,
                                                    level: "sentence",
                                                    content: " The intracranial internal carotid arteries appear normal. "
                                                },
                                                {
                                                    start: 1218,
                                                    end: 1224,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1176,
                                                    end: 1233,
                                                    level: "sentence",
                                                    content: "The anterior and middle cerebral arteries appear normal. "
                                                },
                                                {
                                                    start: 1506,
                                                    end: 1512,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1446,
                                                    end: 1521,
                                                    level: "sentence",
                                                    content: " The intracranial vertebral arteries and the basilar artery appear normal. "
                                                },
                                                {
                                                    start: 1553,
                                                    end: 1559,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1521,
                                                    end: 1568,
                                                    level: "sentence",
                                                    content: "The posterior cerebral arteries appear normal. "
                                                },
                                                {
                                                    start: 1674,
                                                    end: 1680,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1651,
                                                    end: 1722,
                                                    level: "sentence",
                                                    content: " The venous structures appear normal, without evidence of thrombosis.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.004187631487871611,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "imag",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.004187631487871611,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "imag",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 1061,
                                                    end: 1067,
                                                    level: "ngram",
                                                    content: "imaged"
                                                },
                                                {
                                                    start: 977,
                                                    end: 1092,
                                                    level: "sentence",
                                                    content: " There is no evidence of aneurysm, arteriovenous malformation, or thrombosis of the imaged intracranial arteries.\n "
                                                },
                                                {
                                                    start: 4141,
                                                    end: 4147,
                                                    level: "ngram",
                                                    content: "images"
                                                },
                                                {
                                                    start: 4056,
                                                    end: 4164,
                                                    level: "sentence",
                                                    content: " This report is limited to the body part and modality requested, regardless of which images were uploaded.  "
                                                },
                                                {
                                                    start: 4347,
                                                    end: 4353,
                                                    level: "ngram",
                                                    content: "images"
                                                },
                                                {
                                                    start: 4285,
                                                    end: 4450,
                                                    level: "sentence",
                                                    content: "I, Dr. Otto Rapalino as teaching physician, have reviewed the images for this case and if necessary edited the report originally created by Dr. Maria T Braileanu. \n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.004187631487871611,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "are",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 300,
                                                    end: 303,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 261,
                                                    end: 345,
                                                    level: "sentence",
                                                    content: " Multifocal thromboembolic infarctions are better visualized on MRI dated 4/1/2021. "
                                                },
                                                {
                                                    start: 451,
                                                    end: 454,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 345,
                                                    end: 502,
                                                    level: "sentence",
                                                    content: "Focal hypodensities of the left cerebellum, right splenium of the corpus callosum, and left parietal lobe are unchanged and correlate to known infarctions.\n "
                                                },
                                                {
                                                    start: 890,
                                                    end: 893,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 884,
                                                    end: 961,
                                                    level: "sentence",
                                                    content: "There are mild degenerative changes of bilateral temporomandibular joints. \n "
                                                },
                                                {
                                                    start: 1611,
                                                    end: 1614,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 1568,
                                                    end: 1629,
                                                    level: "sentence",
                                                    content: "Bilateral posterior communicating arteries are not present.\n "
                                                },
                                                {
                                                    start: 1964,
                                                    end: 1967,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 1903,
                                                    end: 1984,
                                                    level: "sentence",
                                                    content: "The brachiocephalic artery and bilateral subclavian arteries are widely patent.\n "
                                                },
                                                {
                                                    start: 2465,
                                                    end: 2468,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 2429,
                                                    end: 2477,
                                                    level: "sentence",
                                                    content: " Lungs and Airways: Central airways are patent. "
                                                },
                                                {
                                                    start: 2776,
                                                    end: 2779,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 2770,
                                                    end: 2814,
                                                    level: "sentence",
                                                    content: "There are degenerative changes of the dens. "
                                                },
                                                {
                                                    start: 3039,
                                                    end: 3042,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 2991,
                                                    end: 3084,
                                                    level: "sentence",
                                                    content: "Unchanged multifocal thromboembolic infarctions are better visualized on MRI dated 4/1/2021. "
                                                },
                                                {
                                                    start: 4186,
                                                    end: 4189,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 4164,
                                                    end: 4270,
                                                    level: "sentence",
                                                    content: "If additional reports are required, please contact the appropriate Division of the Radiology Department.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true
                            }
                        ]
                    },
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 0.0,
            automate: true,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.27,
            primary_code_confidence: 0.21,
            primary_predicted_code: "R91.8",
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 10087855,
        type: "CODED",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 11185291,
                    procedure_name: null,
                    procedure_code: "70496",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    automate: false,
                    confidence: -1.0,
                    evidence: [],
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "77",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 1,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 2,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "ACT",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 3,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "I63.9",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 1,
                                type: null,
                                evidence: [],
                                used: false
                            }
                        ]
                    },
                    used: false
                },
                {
                    procedure_id: 11185292,
                    procedure_name: null,
                    procedure_code: "70498",
                    type: null,
                    units: 1.0,
                    sequence_number: 2,
                    automate: false,
                    confidence: -1.0,
                    evidence: [],
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "77",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 1,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "52",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 2,
                                evidence: [],
                                used: true
                            },
                            {
                                modifier_code: "ACT",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 3,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "I63.9",
                                automate: false,
                                confidence: -1.0,
                                sequence_number: 1,
                                type: null,
                                evidence: [],
                                used: false
                            }
                        ]
                    },
                    used: false
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            primary_code_confidence: -1.0,
            primary_predicted_code: null,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 10052467,
        type: "MAPPED",
        identifier: null,
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 11147911,
                    procedure_name: null,
                    procedure_code: "76140",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    automate: false,
                    confidence: -1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        primary_code_confidence: 0.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: true
                }
            ],
            confidence: -1.0
        },
        modifiers: {
            confidence: -1.0,
            automate: false,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: -1.0,
            primary_code_confidence: -1.0,
            primary_predicted_code: null,
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 10059783,
        type: "ASSEMBLED",
        identifier: "3318928",
        procedures: {
            automate: true,
            evidence: [],
            codes: [
                {
                    procedure_id: 11155720,
                    procedure_name: null,
                    procedure_code: "76140",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    automate: true,
                    confidence: 1.0,
                    evidence: [],
                    modifiers: {
                        confidence: 0.0,
                        automate: true,
                        evidence: [],
                        codes: [
                            {
                                modifier_code: "77",
                                automate: false,
                                confidence: 1.0,
                                sequence_number: 1,
                                evidence: [],
                                used: true
                            }
                        ]
                    },
                    diagnoses: {
                        confidence: 0.27,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "R91.8",
                                automate: false,
                                confidence: 0.27,
                                sequence_number: 1,
                                type: null,
                                evidence: [
                                    {
                                        type: "Categorical",
                                        score: 0.10500784882327382,
                                        feature: {
                                            category: "Non-specific",
                                            field: "body_region",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.043968009866781406,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "abnorm",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.03157402076577271,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "prior",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.01344278294668012,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "diagnost outsid",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 49,
                                                    end: 85,
                                                    level: "ngram",
                                                    content: "Diagnostic CT NEURO-VASCULAR OUTSIDE"
                                                },
                                                {
                                                    start: 37,
                                                    end: 167,
                                                    level: "sentence",
                                                    content: " TECHNIQUE: Diagnostic CT NEURO-VASCULAR OUTSIDE WITH INTERPRETATION OR CONSULT, CT HEAD OUTSIDE WITH INTERPRETATION OR CONSULT.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.006724147603631276,
                                        feature: {
                                            category: "XRAY",
                                            field: "procedure_category",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Categorical",
                                        score: 0.006724147603631276,
                                        feature: {
                                            category: "Digital Radiography",
                                            field: "procedure_type",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.004187631487871611,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "appear",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 1161,
                                                    end: 1167,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1117,
                                                    end: 1176,
                                                    level: "sentence",
                                                    content: " The intracranial internal carotid arteries appear normal. "
                                                },
                                                {
                                                    start: 1218,
                                                    end: 1224,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1176,
                                                    end: 1233,
                                                    level: "sentence",
                                                    content: "The anterior and middle cerebral arteries appear normal. "
                                                },
                                                {
                                                    start: 1506,
                                                    end: 1512,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1446,
                                                    end: 1521,
                                                    level: "sentence",
                                                    content: " The intracranial vertebral arteries and the basilar artery appear normal. "
                                                },
                                                {
                                                    start: 1553,
                                                    end: 1559,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1521,
                                                    end: 1568,
                                                    level: "sentence",
                                                    content: "The posterior cerebral arteries appear normal. "
                                                },
                                                {
                                                    start: 1674,
                                                    end: 1680,
                                                    level: "ngram",
                                                    content: "appear"
                                                },
                                                {
                                                    start: 1651,
                                                    end: 1722,
                                                    level: "sentence",
                                                    content: " The venous structures appear normal, without evidence of thrombosis.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.004187631487871611,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "imag",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.004187631487871611,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "imag",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 1061,
                                                    end: 1067,
                                                    level: "ngram",
                                                    content: "imaged"
                                                },
                                                {
                                                    start: 977,
                                                    end: 1092,
                                                    level: "sentence",
                                                    content: " There is no evidence of aneurysm, arteriovenous malformation, or thrombosis of the imaged intracranial arteries.\n "
                                                },
                                                {
                                                    start: 4141,
                                                    end: 4147,
                                                    level: "ngram",
                                                    content: "images"
                                                },
                                                {
                                                    start: 4056,
                                                    end: 4164,
                                                    level: "sentence",
                                                    content: " This report is limited to the body part and modality requested, regardless of which images were uploaded.  "
                                                },
                                                {
                                                    start: 4347,
                                                    end: 4353,
                                                    level: "ngram",
                                                    content: "images"
                                                },
                                                {
                                                    start: 4285,
                                                    end: 4450,
                                                    level: "sentence",
                                                    content: "I, Dr. Otto Rapalino as teaching physician, have reviewed the images for this case and if necessary edited the report originally created by Dr. Maria T Braileanu. \n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.004187631487871611,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "are",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 300,
                                                    end: 303,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 261,
                                                    end: 345,
                                                    level: "sentence",
                                                    content: " Multifocal thromboembolic infarctions are better visualized on MRI dated 4/1/2021. "
                                                },
                                                {
                                                    start: 451,
                                                    end: 454,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 345,
                                                    end: 502,
                                                    level: "sentence",
                                                    content: "Focal hypodensities of the left cerebellum, right splenium of the corpus callosum, and left parietal lobe are unchanged and correlate to known infarctions.\n "
                                                },
                                                {
                                                    start: 890,
                                                    end: 893,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 884,
                                                    end: 961,
                                                    level: "sentence",
                                                    content: "There are mild degenerative changes of bilateral temporomandibular joints. \n "
                                                },
                                                {
                                                    start: 1611,
                                                    end: 1614,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 1568,
                                                    end: 1629,
                                                    level: "sentence",
                                                    content: "Bilateral posterior communicating arteries are not present.\n "
                                                },
                                                {
                                                    start: 1964,
                                                    end: 1967,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 1903,
                                                    end: 1984,
                                                    level: "sentence",
                                                    content: "The brachiocephalic artery and bilateral subclavian arteries are widely patent.\n "
                                                },
                                                {
                                                    start: 2465,
                                                    end: 2468,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 2429,
                                                    end: 2477,
                                                    level: "sentence",
                                                    content: " Lungs and Airways: Central airways are patent. "
                                                },
                                                {
                                                    start: 2776,
                                                    end: 2779,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 2770,
                                                    end: 2814,
                                                    level: "sentence",
                                                    content: "There are degenerative changes of the dens. "
                                                },
                                                {
                                                    start: 3039,
                                                    end: 3042,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 2991,
                                                    end: 3084,
                                                    level: "sentence",
                                                    content: "Unchanged multifocal thromboembolic infarctions are better visualized on MRI dated 4/1/2021. "
                                                },
                                                {
                                                    start: 4186,
                                                    end: 4189,
                                                    level: "ngram",
                                                    content: "are"
                                                },
                                                {
                                                    start: 4164,
                                                    end: 4270,
                                                    level: "sentence",
                                                    content: "If additional reports are required, please contact the appropriate Division of the Radiology Department.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true
                            }
                        ]
                    },
                    used: true
                }
            ],
            confidence: 1.0
        },
        modifiers: {
            confidence: 0.0,
            automate: true,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.27,
            primary_code_confidence: 0.21,
            primary_predicted_code: "R91.8",
            automate: false,
            type: null,
            evidence: [],
            codes: []
        }
    },
    {
        artifact_id: 10059631,
        type: "PREDICTION",
        identifier: "3318928",
        procedures: {
            automate: false,
            evidence: [],
            codes: [
                {
                    procedure_id: 11155546,
                    procedure_name: null,
                    procedure_code: "70496",
                    type: null,
                    units: 1.0,
                    sequence_number: 1,
                    automate: false,
                    confidence: 0.46,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.009839979299211505,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "venou structur",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1631,
                                        end: 1648,
                                        level: "ngram",
                                        content: "VENOUS STRUCTURES"
                                    },
                                    {
                                        start: 1630,
                                        end: 1648,
                                        level: "sentence",
                                        content: " VENOUS STRUCTURES"
                                    },
                                    {
                                        start: 1656,
                                        end: 1673,
                                        level: "ngram",
                                        content: "venous structures"
                                    },
                                    {
                                        start: 1651,
                                        end: 1722,
                                        level: "sentence",
                                        content: " The venous structures appear normal, without evidence of thrombosis.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.008132618629975878,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "cta",
                                type: "ngram",
                                spans: [
                                    { start: 26, end: 29, level: "ngram", content: "CTA" },
                                    {
                                        start: 0,
                                        end: 34,
                                        level: "sentence",
                                        content: "Interpretation of outside CTA Scan"
                                    },
                                    {
                                        start: 970,
                                        end: 973,
                                        level: "ngram",
                                        content: "CTA"
                                    },
                                    {
                                        start: 964,
                                        end: 974,
                                        level: "sentence",
                                        content: " HEAD CTA:"
                                    },
                                    {
                                        start: 1794,
                                        end: 1797,
                                        level: "ngram",
                                        content: "CTA"
                                    },
                                    {
                                        start: 1788,
                                        end: 1798,
                                        level: "sentence",
                                        content: " NECK CTA:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.0066382325542672675,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "structur venou",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1638,
                                        end: 1662,
                                        level: "ngram",
                                        content: "STRUCTURES\n \n The venous"
                                    },
                                    {
                                        start: 1630,
                                        end: 1722,
                                        level: "sentence",
                                        content: " VENOUS STRUCTURES\n \n The venous structures appear normal, without evidence of thrombosis.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.006285068827550909,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "find head",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 235,
                                        end: 254,
                                        level: "ngram",
                                        content: "FINDINGS:\n \n \n HEAD"
                                    },
                                    {
                                        start: 234,
                                        end: 258,
                                        level: "sentence",
                                        content: " FINDINGS:\n \n \n HEAD CT:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.005048378396913559,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "venou structur",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1631,
                                        end: 1648,
                                        level: "ngram",
                                        content: "VENOUS STRUCTURES"
                                    },
                                    {
                                        start: 1630,
                                        end: 1648,
                                        level: "sentence",
                                        content: " VENOUS STRUCTURES"
                                    },
                                    {
                                        start: 1631,
                                        end: 1673,
                                        level: "ngram",
                                        content: "VENOUS STRUCTURES\n \n The venous structures"
                                    },
                                    {
                                        start: 1630,
                                        end: 1722,
                                        level: "sentence",
                                        content: " VENOUS STRUCTURES\n \n The venous structures appear normal, without evidence of thrombosis.\n "
                                    },
                                    {
                                        start: 1656,
                                        end: 1673,
                                        level: "ngram",
                                        content: "venous structures"
                                    },
                                    {
                                        start: 1651,
                                        end: 1722,
                                        level: "sentence",
                                        content: " The venous structures appear normal, without evidence of thrombosis.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004934723765175484,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "head there",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 965,
                                        end: 983,
                                        level: "ngram",
                                        content: "HEAD CTA:\n \n There"
                                    },
                                    {
                                        start: 964,
                                        end: 1092,
                                        level: "sentence",
                                        content: " HEAD CTA:\n \n There is no evidence of aneurysm, arteriovenous malformation, or thrombosis of the imaged intracranial arteries.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004663135201622858,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "head cta",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 965,
                                        end: 973,
                                        level: "ngram",
                                        content: "HEAD CTA"
                                    },
                                    {
                                        start: 964,
                                        end: 974,
                                        level: "sentence",
                                        content: " HEAD CTA:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004449360487197876,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "structur venou",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1638,
                                        end: 1662,
                                        level: "ngram",
                                        content: "STRUCTURES\n \n The venous"
                                    },
                                    {
                                        start: 1630,
                                        end: 1722,
                                        level: "sentence",
                                        content: " VENOUS STRUCTURES\n \n The venous structures appear normal, without evidence of thrombosis.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004057450470428789,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "vein non-vascular",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 2317,
                                        end: 2359,
                                        level: "ngram",
                                        content: "veins enhance normally. \n \n \n NON-VASCULAR"
                                    },
                                    {
                                        start: 2304,
                                        end: 2369,
                                        level: "sentence",
                                        content: " The jugular veins enhance normally. \n \n \n NON-VASCULAR FINDINGS:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.0016206309975073847,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "find ct",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 235,
                                        end: 257,
                                        level: "ngram",
                                        content: "FINDINGS:\n \n \n HEAD CT"
                                    },
                                    {
                                        start: 234,
                                        end: 258,
                                        level: "sentence",
                                        content: " FINDINGS:\n \n \n HEAD CT:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        }
                    ],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        primary_code_confidence: 0.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: true
                },
                {
                    procedure_id: 11155547,
                    procedure_name: null,
                    procedure_code: "70498",
                    type: null,
                    units: 1.0,
                    sequence_number: 2,
                    automate: false,
                    confidence: 0.46,
                    evidence: [
                        {
                            type: "Ngram",
                            score: 0.01040922542942883,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "non-vascular find",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 2347,
                                        end: 2368,
                                        level: "ngram",
                                        content: "NON-VASCULAR FINDINGS"
                                    },
                                    {
                                        start: 2346,
                                        end: 2369,
                                        level: "sentence",
                                        content: " NON-VASCULAR FINDINGS:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.009834565680064912,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "non-vascular find",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 2347,
                                        end: 2368,
                                        level: "ngram",
                                        content: "NON-VASCULAR FINDINGS"
                                    },
                                    {
                                        start: 2346,
                                        end: 2369,
                                        level: "sentence",
                                        content: " NON-VASCULAR FINDINGS:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.008951575887497511,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "neck cta",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1789,
                                        end: 1797,
                                        level: "ngram",
                                        content: "NECK CTA"
                                    },
                                    {
                                        start: 1788,
                                        end: 1798,
                                        level: "sentence",
                                        content: " NECK CTA:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.008680152907554105,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "jugular enhanc",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 2309,
                                        end: 2330,
                                        level: "ngram",
                                        content: "jugular veins enhance"
                                    },
                                    {
                                        start: 2304,
                                        end: 2341,
                                        level: "sentence",
                                        content: " The jugular veins enhance normally. "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.007591844758971046,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "cta origin",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1794,
                                        end: 1824,
                                        level: "ngram",
                                        content: "CTA:\n \n AORTIC ARCH AND ORIGIN"
                                    },
                                    {
                                        start: 1788,
                                        end: 1850,
                                        level: "sentence",
                                        content: " NECK CTA:\n \n AORTIC ARCH AND ORIGIN OF MAJOR CERVICAL VESSELS"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.006283200100582954,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "cta",
                                type: "ngram",
                                spans: [
                                    { start: 26, end: 29, level: "ngram", content: "CTA" },
                                    {
                                        start: 0,
                                        end: 34,
                                        level: "sentence",
                                        content: "Interpretation of outside CTA Scan"
                                    },
                                    {
                                        start: 970,
                                        end: 973,
                                        level: "ngram",
                                        content: "CTA"
                                    },
                                    {
                                        start: 964,
                                        end: 974,
                                        level: "sentence",
                                        content: " HEAD CTA:"
                                    },
                                    {
                                        start: 1794,
                                        end: 1797,
                                        level: "ngram",
                                        content: "CTA"
                                    },
                                    {
                                        start: 1788,
                                        end: 1798,
                                        level: "sentence",
                                        content: " NECK CTA:"
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004559294133237041,
                            feature: {
                                slop: 1,
                                field: "raw_body",
                                in_order: true,
                                ngram: "non-vascular thyroid",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 2347,
                                        end: 2380,
                                        level: "ngram",
                                        content: "NON-VASCULAR FINDINGS:\n \n Thyroid"
                                    },
                                    {
                                        start: 2346,
                                        end: 2402,
                                        level: "sentence",
                                        content: " NON-VASCULAR FINDINGS:\n \n Thyroid: No thyroid nodules. "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004047218545728271,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "there left-sid",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1854,
                                        end: 1875,
                                        level: "ngram",
                                        content: "There is a left-sided"
                                    },
                                    {
                                        start: 1853,
                                        end: 1903,
                                        level: "sentence",
                                        content: " There is a left-sided, four-vessel aortic arch.  "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.0040456457340179,
                            feature: {
                                slop: 1,
                                field: "raw_reasonforvisit",
                                in_order: true,
                                ngram: "abnorm prior",
                                type: "ngram",
                                spans: []
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.0040456457340179,
                            feature: {
                                slop: 2,
                                field: "raw_reasonforvisit",
                                in_order: true,
                                ngram: "abnorm prior",
                                type: "ngram",
                                spans: []
                            },
                            type: "Ngram"
                        }
                    ],
                    modifiers: {
                        confidence: 0.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.0,
                        primary_code_confidence: 0.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    },
                    used: true
                }
            ],
            confidence: 0.46
        },
        modifiers: {
            confidence: 0.0,
            automate: true,
            evidence: [],
            codes: []
        },
        diagnoses: {
            confidence: 0.27,
            primary_code_confidence: 0.21,
            primary_predicted_code: "R91.8",
            automate: false,
            type: null,
            evidence: [],
            codes: [
                {
                    diagnosis_code: "R91.8",
                    automate: false,
                    confidence: 0.27,
                    sequence_number: null,
                    type: null,
                    evidence: [
                        {
                            type: "Categorical",
                            score: 0.10500784882327382,
                            feature: {
                                category: "Non-specific",
                                field: "body_region",
                                type: "categorical"
                            },
                            type: "Categorical"
                        },
                        {
                            type: "Ngram",
                            score: 0.043968009866781406,
                            feature: {
                                slop: 0,
                                field: "raw_reasonforvisit",
                                in_order: true,
                                ngram: "abnorm",
                                type: "ngram",
                                spans: []
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.03157402076577271,
                            feature: {
                                slop: 0,
                                field: "raw_reasonforvisit",
                                in_order: true,
                                ngram: "prior",
                                type: "ngram",
                                spans: []
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.01344278294668012,
                            feature: {
                                slop: 2,
                                field: "raw_body",
                                in_order: true,
                                ngram: "diagnost outsid",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 49,
                                        end: 85,
                                        level: "ngram",
                                        content: "Diagnostic CT NEURO-VASCULAR OUTSIDE"
                                    },
                                    {
                                        start: 37,
                                        end: 167,
                                        level: "sentence",
                                        content: " TECHNIQUE: Diagnostic CT NEURO-VASCULAR OUTSIDE WITH INTERPRETATION OR CONSULT, CT HEAD OUTSIDE WITH INTERPRETATION OR CONSULT.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Categorical",
                            score: 0.006724147603631276,
                            feature: {
                                category: "XRAY",
                                field: "procedure_category",
                                type: "categorical"
                            },
                            type: "Categorical"
                        },
                        {
                            type: "Categorical",
                            score: 0.006724147603631276,
                            feature: {
                                category: "Digital Radiography",
                                field: "procedure_type",
                                type: "categorical"
                            },
                            type: "Categorical"
                        },
                        {
                            type: "Ngram",
                            score: 0.004187631487871611,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "appear",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1161,
                                        end: 1167,
                                        level: "ngram",
                                        content: "appear"
                                    },
                                    {
                                        start: 1117,
                                        end: 1176,
                                        level: "sentence",
                                        content: " The intracranial internal carotid arteries appear normal. "
                                    },
                                    {
                                        start: 1218,
                                        end: 1224,
                                        level: "ngram",
                                        content: "appear"
                                    },
                                    {
                                        start: 1176,
                                        end: 1233,
                                        level: "sentence",
                                        content: "The anterior and middle cerebral arteries appear normal. "
                                    },
                                    {
                                        start: 1506,
                                        end: 1512,
                                        level: "ngram",
                                        content: "appear"
                                    },
                                    {
                                        start: 1446,
                                        end: 1521,
                                        level: "sentence",
                                        content: " The intracranial vertebral arteries and the basilar artery appear normal. "
                                    },
                                    {
                                        start: 1553,
                                        end: 1559,
                                        level: "ngram",
                                        content: "appear"
                                    },
                                    {
                                        start: 1521,
                                        end: 1568,
                                        level: "sentence",
                                        content: "The posterior cerebral arteries appear normal. "
                                    },
                                    {
                                        start: 1674,
                                        end: 1680,
                                        level: "ngram",
                                        content: "appear"
                                    },
                                    {
                                        start: 1651,
                                        end: 1722,
                                        level: "sentence",
                                        content: " The venous structures appear normal, without evidence of thrombosis.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004187631487871611,
                            feature: {
                                slop: 0,
                                field: "raw_reasonforvisit",
                                in_order: true,
                                ngram: "imag",
                                type: "ngram",
                                spans: []
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004187631487871611,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "imag",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 1061,
                                        end: 1067,
                                        level: "ngram",
                                        content: "imaged"
                                    },
                                    {
                                        start: 977,
                                        end: 1092,
                                        level: "sentence",
                                        content: " There is no evidence of aneurysm, arteriovenous malformation, or thrombosis of the imaged intracranial arteries.\n "
                                    },
                                    {
                                        start: 4141,
                                        end: 4147,
                                        level: "ngram",
                                        content: "images"
                                    },
                                    {
                                        start: 4056,
                                        end: 4164,
                                        level: "sentence",
                                        content: " This report is limited to the body part and modality requested, regardless of which images were uploaded.  "
                                    },
                                    {
                                        start: 4347,
                                        end: 4353,
                                        level: "ngram",
                                        content: "images"
                                    },
                                    {
                                        start: 4285,
                                        end: 4450,
                                        level: "sentence",
                                        content: "I, Dr. Otto Rapalino as teaching physician, have reviewed the images for this case and if necessary edited the report originally created by Dr. Maria T Braileanu. \n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        },
                        {
                            type: "Ngram",
                            score: 0.004187631487871611,
                            feature: {
                                slop: 0,
                                field: "raw_body",
                                in_order: true,
                                ngram: "are",
                                type: "ngram",
                                spans: [
                                    {
                                        start: 300,
                                        end: 303,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 261,
                                        end: 345,
                                        level: "sentence",
                                        content: " Multifocal thromboembolic infarctions are better visualized on MRI dated 4/1/2021. "
                                    },
                                    {
                                        start: 451,
                                        end: 454,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 345,
                                        end: 502,
                                        level: "sentence",
                                        content: "Focal hypodensities of the left cerebellum, right splenium of the corpus callosum, and left parietal lobe are unchanged and correlate to known infarctions.\n "
                                    },
                                    {
                                        start: 890,
                                        end: 893,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 884,
                                        end: 961,
                                        level: "sentence",
                                        content: "There are mild degenerative changes of bilateral temporomandibular joints. \n "
                                    },
                                    {
                                        start: 1611,
                                        end: 1614,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 1568,
                                        end: 1629,
                                        level: "sentence",
                                        content: "Bilateral posterior communicating arteries are not present.\n "
                                    },
                                    {
                                        start: 1964,
                                        end: 1967,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 1903,
                                        end: 1984,
                                        level: "sentence",
                                        content: "The brachiocephalic artery and bilateral subclavian arteries are widely patent.\n "
                                    },
                                    {
                                        start: 2465,
                                        end: 2468,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 2429,
                                        end: 2477,
                                        level: "sentence",
                                        content: " Lungs and Airways: Central airways are patent. "
                                    },
                                    {
                                        start: 2776,
                                        end: 2779,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 2770,
                                        end: 2814,
                                        level: "sentence",
                                        content: "There are degenerative changes of the dens. "
                                    },
                                    {
                                        start: 3039,
                                        end: 3042,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 2991,
                                        end: 3084,
                                        level: "sentence",
                                        content: "Unchanged multifocal thromboembolic infarctions are better visualized on MRI dated 4/1/2021. "
                                    },
                                    {
                                        start: 4186,
                                        end: 4189,
                                        level: "ngram",
                                        content: "are"
                                    },
                                    {
                                        start: 4164,
                                        end: 4270,
                                        level: "sentence",
                                        content: "If additional reports are required, please contact the appropriate Division of the Radiology Department.\n "
                                    }
                                ]
                            },
                            type: "Ngram"
                        }
                    ],
                    used: true
                }
            ]
        }
    }
];
exports.fromCAC = fromCAC;
//# sourceMappingURL=from-cac.fixtures.js.map